import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import * as classes from "./BowerModal.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import "./BowerModal.css";
import Hotspot from "../UI/Hotspot/Hotspot";
import usePopupImage from "./usePopupImage";
import BackgroundImage from "gatsby-background-image";
import useScreenWidth from "../../Hooks/useScreenWidth";
import { convertToBgImage } from "gbimage-bridge";
import { getImage } from "gatsby-plugin-image";

Modal.setAppElement("body");

const ModalContentContrainer = styled.div`
  display: block;
  text-align: center;
  gap: ${(props) =>
    props.device == "DESKTOP" ? "4em" : props.device == "TABLET" ? 0 : 0};
  /* gap: 4.5em; */
  position: ${(props) => (props.device == "DESKTOP" ? "absolute" : "relative")};
  overflow: auto;
  inset: 0;
  width: 100%;
  padding: 2.5em;
  text-align: left;
  text-align: justify;
  @media screen and (min-width: 1021px) {
    display: grid;
    grid-template-columns: 47fr 56fr;
  }
  @media screen and (max-width: 1020px) {
    padding-top: 20px;
  }

  & .artwork {
    max-width: 87%;
    z-index: -1;
    @media screen and (min-width: 1021px) {
      max-width: 100%;
    }
  }
  &.DESKTOP {
    & > div > h2 {
      text-align: left;
    }
    &.HaircareandGrooming {
      padding-bottom: 0;
      & .artwork {
        max-width: 100%;
      }
    }
    &.PersonalandFeminineHygiene {
      padding-bottom: 0;
      & .artwork {
        max-width: 100%;
      }
    }
    &.DentalCare {
      padding-bottom: 0;
    }
    &.BathroomSinkCabinet {
      & .artwork {
        max-width: 82%;
      }
    }
    &.KitchenDrawer {
      padding-right: 0;
      & .artwork {
        align-self: end;
        justify-self: end !important;
      }
    }
    &.KitchenSink {
      padding-bottom: 0;
      & .artwork {
        width: 100%;
      }
    }
    &.UtilityRoom {
      & .artwork {
        max-width: 96%;
        align-self: center !important;
      }
    }
  }

  &.TABLET {
    & .artwork {
      margin-top: 30px;
      margin-left: auto;
      margin-right: auto;
    }
    padding-bottom: 20px;
    &.DentalCare {
      padding-bottom: 0;
    }
    &.PersonalandFeminineHygiene {
      padding-bottom: 0;
    }
    &.BathroomSinkCabinet {
      & .artwork {
        max-width: 70%;
      }
    }
    &.KitchenDrawer {
      padding-bottom: 0;
      & .artwork {
        max-width: 60%;
      }
    }
  }
  &.MOBILE {
    padding-bottom: 20px;
    &.DentalCare {
      padding-bottom: 0;
    }
    &.PersonalandFeminineHygiene {
      padding-bottom: 0;
    }
    &.BathroomSinkCabinet {
      & .artwork {
        max-width: 70%;
      }
    }
    &.KitchenDrawer {
      padding-bottom: 0;
      & .artwork {
        max-width: 60%;
      }
    }
  }
`;

const ModalHeading = styled.h2`
  font-size: ${(props) => (props.device == "MOBILE" ? "left" : "4.2em")};
  margin: 0 0 0.625em 0;
  padding: ${(props) => (props.device == "DESKTOP" ? "" : "0.2em 6.5% 0 6.5%")};
  color: #1f3b35;
  text-align: ${(props) => (props.device == "DESKTOP" ? "left" : "center")};
`;

const ModalHeading3 = styled.h3`
  font-size: 2.4em;
  margin: ${(props) =>
    props.device == "DESKTOP" ? "1em 0 0.2em 0" : "1.667em 0 0.3em 0"};
  padding: ${(props) =>
    props.device == "DESKTOP"
      ? "0.2em 0"
      : props.device == "TABLET"
      ? "0 6.5%"
      : "0 6.5%"};
  color: #1f3b35;

  & > span {
    display: block;
    font-family: "Basier Circle", sans-serif;
    font-size: 0.583em;
  }
`;

const ModalParagraph = styled.p`
  font-size: 1.6em;
  line-height: 1.3125em;
  color: #1f3b35;
  margin: ${(props) => (props.device == "DESKTOP" ? "1em 0" : "2em 0")};
  @media screen and (max-width: 960px) {
    padding-left: 6.5%;
    padding-right: 6.5%;
  }
`;

const ModalListGroup = styled.div`
  box-sizing: border-box;
  color: #1f3b35;
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 1.6em;
  /* margin: 0.2em 0; */
`;

const ModalDataSection = styled.section`
  font-size: 1.15em;
  padding: ${(props) =>
    props.device == "DESKTOP"
      ? "0.2em 0"
      : props.device == "TABLET"
      ? "2em 6.5%"
      : "0 6.5%"};
`;
const ModalDYK = styled.section`
  margin: ${(props) =>
    props.device == "DESKTOP"
      ? "2em 0"
      : props.device == "TABLET"
      ? "2em 6.5%"
      : "2em 0"};
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 2em;
  text-align: center;
`;

const ModalListItem = styled.span`
  font-family: "Test Domaine Display", serif;
  white-space: pre-wrap;
`;
const ModalListQty = styled.span`
  font-family: "Basier Circle", sans-serif;
`;
const ListItem = ({ item, qty }) => (
  <ModalListGroup>
    <ModalListItem>
      {item.replace("(packaging)", "\n(packaging)")}
    </ModalListItem>
    <ModalListQty>{qty}</ModalListQty>
  </ModalListGroup>
);

const BowerModal = ({
  placeholderImages,
  images,
  popupEnabled,
  setpopupEnabled,
  popupData,
}) => {
  const { screenWidth, screenHeight } = useScreenWidth();
  const [device, setDevice] = useState("MOBILE");
  const [modalContentDom, setmodalContentDom] = useState();
  const modalInnerContentRef = useRef();
  useEffect(() => {
    if (screenWidth <= 425) {
      setDevice("MOBILE");
    } else if (screenWidth <= 1020) {
      setDevice("TABLET");
    } else {
      setDevice("DESKTOP");
    }
  }, [screenWidth]);

  if (!popupData) {
    return <div></div>;
  }

  return (
    <>
      <Modal
        portalClassName={classes.Modal}
        overlayClassName={classes.Overlay}
        className={classes.Content}
        preventScroll={false}
        isOpen={popupEnabled}
        contentRef={(node) => {
          setmodalContentDom(node);
        }}
      >
        <BackgroundImage
          {...popupData.popupImages.backgroundImage}
          style={{ backgroundRepeat: "repeat-y" }}
        >
          {/* {device == "MOBILE" && (
            <GatsbyImage
              image={placeholderImages.mobile}
              style={{ opacity: 0 }}
              alt="placeholder image"
            ></GatsbyImage>
          )} */}
          {/* {device == "TABLET" && (
            <GatsbyImage
              image={placeholderImages.tablet}
              style={{ opacity: 0 }}
              alt="placeholder image"
            ></GatsbyImage>
          )} */}
          {device == "DESKTOP" && (
            <GatsbyImage
              image={placeholderImages.desktop}
              style={{ opacity: 0 }}
              alt="placeholder image"
            ></GatsbyImage>
          )}
          <ModalContentContrainer
            ref={modalInnerContentRef}
            device={device}
            className={[
              device,
              popupData.popupContent.heading.replaceAll(" ", ""),
            ].join(" ")}
          >
            <div>
              <ModalHeading>{popupData.popupContent.heading}</ModalHeading>
              <ModalParagraph device={device}>
                {popupData.popupContent.p1}
              </ModalParagraph>
              <div>
                <ModalHeading3 device={device}>
                  Annual average waste: {popupData.averageWaste}
                  <span>Based on 2 person household</span>
                </ModalHeading3>
                <ModalDataSection device={device}>
                  {Object.keys(popupData.popupTableData).map((key) => (
                    <ListItem
                      key={key}
                      item={key}
                      qty={popupData.popupTableData[key]}
                    ></ListItem>
                  ))}
                </ModalDataSection>
              </div>
              {popupData.popupContent.p2 && (
                <ModalDYK device={device}>
                  <ModalHeading3 device={device} style={{ margin: "0 auto" }}>
                    Did you know?
                  </ModalHeading3>
                  <ModalParagraph style={{ margin: 0, padding: 0 }}>
                    {popupData.popupContent.p2}
                  </ModalParagraph>
                </ModalDYK>
              )}
            </div>
            {/* <div> */}
            {device === "MOBILE" || device == "TABLET" ? (
              <GatsbyImage
                className="artwork"
                alt="Artwork"
                image={popupData.popupImages.artworkImageMobile}
                style={{
                  textAlign: "center",
                  margin: "4em auto 0 auto",
                  display: "inherit",
                  // alignSelf: "end",
                }}
              ></GatsbyImage>
            ) : (
              <GatsbyImage
                className="artwork"
                alt="Artwork"
                image={popupData.popupImages.artworkImageDesktop}
                style={{
                  textAlign: "right",
                  justifySelf: "center",
                  alignSelf: "end",
                }}
              ></GatsbyImage>
            )}
            {/* </div> */}
          </ModalContentContrainer>
          <Hotspot
            onHotspotClick={() => setpopupEnabled(false)}
            onMouseEnter={() => null}
            onMouseLeave={() => null}
            hotspotData={{
              x: device == "MOBILE" ? 94 : 95,
              y: device == "MOBILE" ? 4 : 5,
              rotate: 45,
            }}
          ></Hotspot>
        </BackgroundImage>
      </Modal>
    </>
  );
};

export default BowerModal;
